export const COLOR_ACTIVE = 'success';
export const COLOR_INACTIVE = 'default';